﻿import { upOrDownOnScrollWheel } from './HelperFunctions'

export const navigationFunctions = () => {
    const header = document.querySelector<HTMLElement>('.main-site-header')
    if (!header) return

    const burgerMenu = document.querySelector<HTMLDialogElement>('.burger-menu')
    if (!burgerMenu) return

    closeNavOnBodyClick()
    burgerToggle(header, burgerMenu)
    makeNavSticky(header)
    adjustNavWidth()
    addBackBtn()
    openNavLevelsClickHandler()
    applyBackBtnClickHandler()
}

const openNavigationMenu = (item: HTMLElement, menu: HTMLElement) => {
    if (item.classList.contains('open')) return
    item.classList.add('open')
    item.setAttribute('aria-expanded', 'true')
    menu.setAttribute('aria-hidden', 'false')
    menu.querySelector<HTMLAnchorElement>('a')?.focus()
}

const closeNavigationMenu = (item: HTMLElement, menu: HTMLElement) => {
    if (!item.classList.contains('open')) return
    item.classList.remove('open')
    item.setAttribute('aria-expanded', 'false')
    menu.setAttribute('aria-hidden', 'true')
    item.querySelector<HTMLButtonElement>('.icon')?.focus()
}

const toggleNavigationMenu = (item: HTMLElement, menu: HTMLElement) => {
    item.classList.toggle('open')
    item.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false')
    menu.setAttribute('aria-hidden', item.classList.contains('open') ? 'false' : 'true')
    if (item.classList.contains('open')) {
        menu.querySelector<HTMLAnchorElement>('a')?.focus()
    } else {
        item.querySelector<HTMLButtonElement>('.icon')?.focus()
    }
}

const burgerToggle = (header: HTMLElement, burgerMenu: HTMLDialogElement) => {
    const burgerMenuToggles = [
        ...header.querySelectorAll('.main-site-header__burger-toggle'),
        ...burgerMenu.querySelectorAll('.main-site-header__burger-toggle')
    ]

    burgerMenu.setAttribute('aria-hidden', 'true')

    burgerMenuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false')
        toggle.setAttribute('aria-controls', 'burger-menu')
        
        toggle.addEventListener('click', () => {
            document.body.classList.toggle('overlay-open')

            if (burgerMenu.open) {
                burgerMenu.close()
                burgerMenuToggles.forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', 'false')
                    burgerMenu.setAttribute('aria-hidden', 'true')
                })
                return
            }

            burgerMenu.showModal()
            burgerMenuToggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'true')
                burgerMenu.setAttribute('aria-hidden', 'false')
            })

            const menuItems = burgerMenu?.querySelectorAll<HTMLElement>('.hasChildren')

            menuItems.forEach((menuItem: HTMLUListElement) => {
                const menu = menuItem.querySelector<HTMLElement>('.navList')
                if (!menu) return

                closeNavigationMenu(menuItem, menu)
            })

            const firstLink: HTMLAnchorElement | null = burgerMenu.querySelector('a')
            if (firstLink) {
                setTimeout(() => {
                    firstLink.focus()
                }, 100)
            }

            burgerMenu.addEventListener('close', function closeDialog() {
                burgerMenu.close()
                burgerMenuToggles.forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', 'false')
                    burgerMenu.setAttribute('aria-hidden', 'true')
                })
                setTimeout(() => {
                    const items = burgerMenu?.querySelectorAll<HTMLElement>('.mainNav-widget .hasChildren')
                    items.forEach((item: HTMLUListElement) => {
                        const menu = item.querySelector<HTMLElement>('.navList')
                        if (!menu) return
                        closeNavigationMenu(item, menu)
                    })
                    burgerMenu.removeEventListener('close', closeDialog)
                }, 300);
            })

            window.addEventListener('resize', function closeDialogResize() {
                if (window.innerWidth >= 991) {
                    burgerMenu.close()
                    burgerMenuToggles.forEach((toggle) => {
                        toggle.setAttribute('aria-expanded', 'false')
                        burgerMenu.setAttribute('aria-hidden', 'true')
                    })
                    document.body.classList.remove('overlay-open')
                    window.removeEventListener('resize', closeDialogResize)
                }
            })
        })
    })
}

const openNavLevelsClickHandler = () => {
    const hasChildren = document?.querySelectorAll('.main-site-header .hasChildren, .burger-menu .hasChildren')
    hasChildren.forEach((el) => {
        const icons = el.querySelectorAll('.icon')
        icons.forEach((icon) => {
            icon.addEventListener('click', (event) => {
                event.stopImmediatePropagation()
                const target = event.target as HTMLElement
                const parent = target.parentElement
                if (!parent) return
                parent.classList.toggle('open')

                const siblings = parent.closest('.navList')?.querySelectorAll('.hasChildren')
                siblings?.forEach((sibling) => {
                    if (sibling !== parent) {
                        sibling.classList.remove('open')
                    }
                })
            })
        })

        el.addEventListener('mouseenter', (event) => {
            if (window.innerWidth < 991) return
            el.classList.toggle('open')
        })
        
        el.addEventListener('mouseleave', (event) => {
            if (window.innerWidth < 991) return
            event.preventDefault()
            event.stopPropagation()
            event.stopImmediatePropagation()
            el.classList.remove('open')
        })
    })
}

const applyBackBtnClickHandler = () => {
    const backBtns = document.querySelectorAll(".nav-back-btn");

    backBtns.forEach((el) => {
        el.addEventListener("click", () => {
            el.closest(".hasChildren")?.classList.remove("open");
        });
    });
};

const closeNavOnBodyClick = () => {
    window.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;
        const nav = document.querySelector(".navList");
        const openNavs = document.querySelectorAll(".hasChildren");

        if (target !== nav && !nav?.contains(target)) {
            openNavs.forEach((el) => {
                el.classList.remove("open");
            });
        }
    });
};

//Changes to the DOM
const addBackBtn = () => {
    const hasChildren = document?.querySelectorAll("li.hasChildren");

    if (!hasChildren) return;

    hasChildren.forEach((el) => {
        const backBtn = document.createElement("div");
        backBtn.classList.add("nav-back-btn");
        backBtn.innerHTML = "Back";
        el.querySelector(".navList")?.prepend(backBtn);
    });
};

const makeNavSticky = (header: HTMLElement) => {
    upOrDownOnScrollWheel(header)
}

const adjustNavWidth = () => {
    const links = document.querySelectorAll(
        ".main-site-header .navList > .last > ul > li"
    );

    links.forEach((link) => {
        if (link.classList.contains("hasChildren")) {
            const icon = link.querySelector<HTMLSpanElement>(".icon");
            icon?.addEventListener("click", () => {
                const tile = link.querySelector("ul");
                const tileSize = tile?.getBoundingClientRect();
                const parentNav = link.parentElement?.closest("ul");

                if (!tile || !tileSize || !parentNav) return;
                const totalTileSize: number = tileSize.right + tileSize.width;
                const windowMaxWidth: number = Math.max(
                    window.innerWidth || document.documentElement.clientWidth
                );

                if (totalTileSize > windowMaxWidth) {
                    tile.style.width = "fit-content";
                    parentNav.style.left = "auto";
                    parentNav.style.right = "100%";
                }
            });
        }
    });
};
